/* unplugin-vue-components disabled */import { render } from "./PointsMarket.vue?vue&type=template&id=20519d7a"
import script from "./PointsMarket.vue?vue&type=script&lang=js"
export * from "./PointsMarket.vue?vue&type=script&lang=js"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__